import React from 'react';
import { useDispatch } from 'react-redux';
import { ClergyCompReportSettings } from '../../arc/models/arc-epi-props';
import { setCurrentContext, setMapContext, setReportContext } from '../clergy-comp-report-slice';
import { CurrentContext, MapContext, ReportContext } from '../models';

interface Props {
	settings: ClergyCompReportSettings
}

export function HomeMap(props: Props) {

	const dispatch = useDispatch();
	const onDomesticClick = () => {
		dispatch(setMapContext(MapContext.DOMESTIC));
		dispatch(setCurrentContext(CurrentContext.DOMESTIC));
		dispatch(setReportContext(ReportContext.PROVINCE));
	};

	const onInternationalClick = () => {
		dispatch(setMapContext(MapContext.INTERNATIONAL));
		dispatch(setCurrentContext(CurrentContext.INTERNATIONAL));
		dispatch(setReportContext(ReportContext.DIO));
	};

	return (
		<div className='clergycomp-infographic-split'>
			<div className='clergycomp-infographic-split-image' role='button' tabIndex={0} onClick={() => onDomesticClick()} onKeyDown={() => onDomesticClick()} >
				<h3>{props?.settings?.domesticLabel}</h3>
				<img src='/static/img/clergy-comp/dom_thumb.jpg' alt='domestic map' />
			</div>
			<div className='clergycomp-infographic-split-image' role='button' tabIndex={0} onClick={() => onInternationalClick()} onKeyDown={() => onInternationalClick()}>
				<h3>{props?.settings?.nonDomesticLabel}</h3>
				<img src='/static/img/clergy-comp/int_thumb.jpg' alt='international map' />
			</div>
		</div>
	);
}